// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io> */
/* SPDX-License-Identifier: AGPL-3.0-only */

* {
    box-sizing: border-box;
}

html,
body,
#root {
    min-height: 100%;
    margin: 0;
}

body {
    font-family:
        Inter,
        Roboto,
        Helvetica,
        Arial,
        sans-serif;
    background: #f7f8fa;
}

a {
    color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE,2CAA2C;;AAE3C;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI;;;;;kBAKc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io> */\n/* SPDX-License-Identifier: AGPL-3.0-only */\n\n* {\n    box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n    min-height: 100%;\n    margin: 0;\n}\n\nbody {\n    font-family:\n        Inter,\n        Roboto,\n        Helvetica,\n        Arial,\n        sans-serif;\n    background: #f7f8fa;\n}\n\na {\n    color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
